import FieldData from './Currency'
export default FieldData
